import * as tracking from 'dibs-tracking';
import {
    SORT,
    CURRENCY,
    FILTER_REFINE_SEARCH,
    RESERVE_PRICE,
    SUBJECT_MATTER,
    MEASUREMENTS,
} from '../../../finding/SbSharedRefineMenu/sbSharedRefineMenuConstants';

type TrackEventArguments = Parameters<typeof tracking.trackEvent>;
type TrackEventEventArgument = TrackEventArguments[1];
export const trackFilterClick = (filterName: string, isExpanding: boolean): void => {
    tracking.trackEvent({
        category: 'results page refinement',
        action: isExpanding ? 'expand facet' : 'collapse facet',
        // category, item type, price, etc
        label: filterName.toLowerCase(),
    });
};

export const trackSeeMoreClick = (filterName: string): void => {
    tracking.trackEvent({
        category: 'results page refinement',
        action: 'show more options',
        label: `${filterName.toLowerCase()} selected`,
    });
};

export const trackPillDeselectClick = (filterName: string): void => {
    tracking.trackEvent({
        category: 'results page refinement',
        action: 'filter pill deselected',
        label: filterName.toLowerCase(),
    });
};

export const trackSearchWithinResults = (event: TrackEventEventArgument): void => {
    tracking.trackEvent(
        {
            category: 'results page refinement',
            action: 'search within results',
        },
        event
    );
};

export const trackFilterChange = ({
    filterName,
    filterValue,
    isFromTypeahead,
    isDeselected,
    triggerType,
    ga = {},
    event = undefined,
    isInteractiveEvent,
}: {
    filterName?: string;
    filterValue?: { urlLabel: string };
    isDeselected?: boolean;
    isFromTypeahead?: boolean;
    isInteractiveEvent?: boolean;
    triggerType: unknown;
    ga?: Record<string, unknown>;
    event?: TrackEventEventArgument;
}): void => {
    // Used in filterActions.updateUriRef, but some filters have unique tracking or no tracking at all
    if (!filterName) {
        return;
    }

    let trackingLabel = filterValue?.urlLabel;
    const selectedCopy = isDeselected ? 'deselected' : 'selected';
    const filterTrackingBlacklist = [SORT, CURRENCY];

    // categories should be just l2, l3, l4, etc.
    // refineSearch should be refine search
    let trackingFilterName = filterName
        .replace('category', '')
        .replace(FILTER_REFINE_SEARCH, 'refine search')
        .toLowerCase();

    if (filterName === RESERVE_PRICE) {
        trackingLabel = 'No Reserve';
        trackingFilterName = 'reserve price';
    } else if (filterName === SUBJECT_MATTER) {
        trackingLabel = filterValue?.urlLabel;
        trackingFilterName = 'subject matter';
    } else if (filterName === MEASUREMENTS) {
        trackingLabel = 'true';
        trackingFilterName = 'dimensions';
    }

    // don't fire filter tracking for blacklisted filters
    if (!filterTrackingBlacklist.includes(filterName)) {
        tracking.trackEvent(
            {
                category: `results page facet ${selectedCopy}`,
                //  This takes the value of the filter heading (except for category which will take (l2, l3, l4)
                action: `${trackingFilterName} ${selectedCopy}`,
                // This takes the value of the selection chosen (ex. paintings, tables, seating, etc...)
                // When choice is selected from the 'see more' modal, eventLabel will also include 'from modal' (ex. eventLabel: gemstone selected from modal)
                label: `${trackingLabel}${isFromTypeahead ? ' from modal' : ''}`,
                additional: {
                    ...(triggerType ? { triggerType } : {}), // only add triggerType if it is truthy
                },
                isInteractiveEvent,
                ...ga,
            },
            event
        );
    }
};
